import moment from 'moment-timezone';

import { Thread } from '@models/conversational/thread.model';
import { ConversationalTheme } from '@models/types/conversational-theme';

import { ApiAdapter } from './adapter';
import { FileLinkAdapter } from './file-link.adapter';
import { FocusRangeAdapter } from './focus-range.adapter';
import { ThreadCommentAdapter } from './thread-comment.adapter';
import { UserAdapter } from './user.adapter';

export class ThreadAdapter extends ApiAdapter<Thread> {
  private userAdapter = new UserAdapter();
  private threadCommentAdapter = new ThreadCommentAdapter();
  private focusRangeAdapter = new FocusRangeAdapter();
  private fileLinkAdapter = new FileLinkAdapter();

  get(json): Thread {
    const thread = new Thread({
      id: json['thread_id'],
      author: this.userAdapter.get(json['created_by']),
      title: '',
      createdAt: moment.tz(json['creation_date'], moment.tz.guess()),
      updatedAt: json['update_date'] ? moment.tz(json['update_date'], moment.tz.guess()) : null,
      body: json['body'],
      starred: json['star'],
      themes: json['themes'].map((key) => ConversationalTheme[key]),
      focusList: this.focusRangeAdapter.list(json['focus']),
      links: this.fileLinkAdapter.list(json['files']),
      users: this.userAdapter.list(json['contacts']),
    });
    thread.comments = this.threadCommentAdapter.list(json['comments'], thread);
    return thread;
  }
}
